import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { SymptomMatrix } from './components/SymptomMatrix';
import { Method } from './components/Method';
import { ProductStack } from './components/ProductStack';
import { Testimonials } from './components/Testimonials';
import { PricingClose } from './components/PricingClose';
import { GuaranteeBlock } from './components/GuaranteeBlock';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // eslint-disable-next-line
      !function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments as any) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else if (b.head) {
          b.head.appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', '2004040883542100');
      window.fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <SymptomMatrix data-id="element-4" />
        <Method data-id="element-5" />
        <ProductStack data-id="element-6" />
        <Testimonials data-id="element-7" />
        <PricingClose data-id="element-8" />
        <GuaranteeBlock data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}